import React from 'react';
import { Layout, Typography, Row, Col, List, Image } from 'antd';
import { Helmet } from 'react-helmet';
import './Home.css';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const HomePage = () => {
  return (
    <Content>
      <Helmet>
        <title>Chevron Technology Marketing</title>
        <meta name="description" content="Chevron Technology Marketing home page with links to ART and CLG websites and information about New Business Development" />
        <meta name="keywords" content="Chevron Lummus Global, CLG, Advanced Refining Technologies, ART, Chevron Technology Marketing New Business Development, TEMA" />
      </Helmet>

      {/* Hero Section */}
      <div className="home-hero">
        <div className="home-hero-image" style={{ backgroundImage: "url('/images/tema-home-hero.jpg')" }}>
          <Title level={1}><a href="/aboutTema">technology marketing</a></Title>
        </div>
        <div className="home-hero-featurelinks">
          <Title level={2}>News</Title>
          <List
            className="arrows-after"
            style={{ marginTop: '50px' }}
            dataSource={[
              { title: 'CLG press releases', url: 'https://www.chevronlummus.com/News-Resources/News-Releases' },
              { title: 'ART press releases', url: 'https://www.arthydroprocessing.com/s/pressroom' }
            ]}
            renderItem={(item: { title: string; url: string }) => (
              <List.Item>
                <a href={item.url} target="_blank" rel="noopener noreferrer">{item.title}</a>
              </List.Item>
            )}
          />
        </div>
      </div>

      {/* Icon Columns */}
      <div className="multi-column multi-column-icons">
        <Row gutter={[24, 24]}>
          <Col xs={24} md={8}>
            <div className="icon-column">
              <Image src="/images/icons/art-icon.png" alt="art catalyst icon" preview={false} />
              <Title level={4}>ART catalysts</Title>
              <Paragraph>
                <a href="https://www.arthydroprocessing.com/s/" target="_blank" rel="noopener noreferrer">
                  ART is a leading supplier<br /> of hydroprocessing<br /> catalysts
                </a>
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div className="icon-column">
              <Image src="/images/icons/data-science-blue.png" alt="new business development icon" preview={false} />
              <Title level={4}>New business development</Title>
              <Paragraph>
                <a href="/newBusinessDevelopment">
                  TEMA commercializes<br /> Chevron downstream<br /> technologies
                </a>
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div className="icon-column-last">
              <Image src="/images/icons/CLG-Tema-Icon-NEW.png" alt="clg technology icon" preview={false} />
              <Title level={4}>CLG technology</Title>
              <Paragraph>
                <a href="https://www.chevronlummus.com/" target="_blank" rel="noopener noreferrer">
                  The leading licensor of hydroprocessing and other associated bottom-of-the-barrel upgrading technologies
                </a>
              </Paragraph>
            </div>
          </Col>
        </Row>
      </div>

      {/* Full Width Promo */}
      <div className="full-width-promo">
        <div className="full-width-promo-featurelink">
          <Title level={2}>
            <a href="/refinersByRefiners">Technology developed by refiners for refiners</a>
          </Title>
        </div>
        <div className="full-width-promo-image" style={{ backgroundImage: "url('/images/home-workers.jpg')" }}></div>
      </div>
    </Content>
  );
};

export default HomePage;